import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

// 发版后旧 chunk 缓存失效时自动刷新，避免登录成功但路由跳转失败
router.onError((error) => {
  const isChunkError =
    error.name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk .* failed/i.test(error.message)
  if (isChunkError) {
    const reloadKey = 'jinli_admin_chunk_reload'
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1')
      window.location.reload()
    } else {
      sessionStorage.removeItem(reloadKey)
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
